import { FC } from 'react'
import { useDispatch } from 'react-redux'
import { Form, Formik } from 'formik'
import { isEmpty } from 'lodash'

import { UserProcedure } from 'Api'
import { closeModal } from 'store/actions/modals'
import { Select } from 'components/Forms'
import BaseModal from 'components/Modals/BaseModal'
import { Alert, Button } from 'ui'

import { t } from 'translations'

type ScheduleSelectAutofillProcedureModalprops = {
  proceduresOptions: UserProcedure[]
  userProceduresById: Record<string, UserProcedure>
  autoFillSelection: (procedure: UserProcedure) => void
}

const ScheduleSelectAutofillProcedureModal: FC<ScheduleSelectAutofillProcedureModalprops> = ({ proceduresOptions, userProceduresById, autoFillSelection }) => {
  const dispatch = useDispatch()

  const onSubmit = (values: { procedureId: string }) => {
    const chosenProcedure = userProceduresById[values.procedureId]
    autoFillSelection(chosenProcedure)
    dispatch(closeModal())
  }

  const selectOptions = !isEmpty(proceduresOptions) ? proceduresOptions : [{ _id: '', name: t('manager.schedule.AUTOFILL_PROCEDURE_MODAL.NO_PROCEDURE') }]

  return (
    <BaseModal hideButtons title="manager.schedule.AUTOFILL_PROCEDURE_MODAL">
      <Formik enableReinitialize={true} initialValues={{ procedureId: proceduresOptions[0]?._id ?? '' }} onSubmit={values => onSubmit(values)}>
        <Form>
          <Alert variant="warning" show={isEmpty(proceduresOptions)}>
            {t('manager.schedule.AUTOFILL_PROCEDURE_MODAL.NO_PROCEDURE_WARNING')}
          </Alert>
          <Select module="manager.schedule.EDIT_MODAL" name="procedureId" options={selectOptions} disabled={isEmpty(proceduresOptions)} />
          {/* Submit & Close buttons */}
          <div className="mt-2">
            <Button className="mr-2" color="primary" type="submit">
              {t('SUBMIT')}
            </Button>
            <Button color="secondary" outlined onClick={() => dispatch(closeModal())}>
              {t(`actions.CLOSE`)}
            </Button>
          </div>
        </Form>
      </Formik>
    </BaseModal>
  )
}

export default ScheduleSelectAutofillProcedureModal
